import { Button, ButtonGroup, Text, useColorModeValue } from '@chakra-ui/react';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

const ButtonTabV4 = ({ setTab, tab, TABS }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabBg = useColorModeValue('light.100', 'dark.100');
  const textColor = useColorModeValue('dark.100', 'light.100');

  return (
    <ButtonGroup
      isAttached
      w="100%"
      overflow="hidden"
      borderBottom={'1px solid'}
      borderColor="#272E48"
    >
      {TABS?.filter((item) => !item.hidden)?.map((item) => (
        <Button
          key={item.label}
          onClick={() => {
            if (typeof setTab === 'function') {
              setTab(item.value);
            }
            setSearchParams({ tab: item.value });
          }}
          w={'100%'}
          className="text-overflow"
          color={tab === item.value ? textColor : textColor}
          borderBottom={tab === item.value ? '2px solid' : ''}
          borderColor={tab === item.value ? 'brand.500' : ''}
          _hover={{
            bg: 'unset',
            color: 'brand.500',
            borderBottom: '2px solid',
            borderColor: 'brand.500'
          }}
          borderRadius={'0'}
          bg="unset"
        >
          <Text className="text-overflow">{item.label}</Text>
        </Button>
      ))}
    </ButtonGroup>
  );
};

export default ButtonTabV4;
